/**
 * Resolve the base URL this widget bundle is served from, so cross-origin embeds
 * (booking.js hosted on widget.propelsia.ai, loaded into a pro's own site) fetch
 * sibling assets — the country-flag SVGs — from the WIDGET host instead of the
 * host page's origin (where `/image/flags/...` would 404).
 *
 * Captured at module load: while the IIFE bundle executes synchronously,
 * `document.currentScript` points to our own <script> (valid even with `defer`).
 * Fallback: scan for a <script> whose src matches our bundle filename, for the
 * rare case `currentScript` is unavailable (re-injected / inline execution).
 */

function resolveBundleSrc(): string | null {
  if (typeof document === 'undefined') return null;
  const current = (document.currentScript as HTMLScriptElement | null)?.src;
  if (current) return current;
  const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'));
  const match = scripts.find((s): boolean => /\/(booking|gift-card)(\.[a-z0-9]+)*\.js(\?.*)?$/i.test(s.src));
  return match?.src ?? null;
}

const BUNDLE_SRC = resolveBundleSrc();

/**
 * Directory URL the bundle is served from, WITHOUT trailing slash (e.g.
 * `https://widget.propelsia.ai`), or `null` if it couldn't be resolved.
 */
export const WIDGET_ASSET_BASE_URL: string | null = BUNDLE_SRC
  ? new URL('.', BUNDLE_SRC).href.replace(/\/$/, '')
  : null;

/**
 * Base URL for country-flag SVGs served next to the bundle (`/image/flags`).
 * `null` when the origin is unknown → consumers fall back to their same-origin
 * default (`DEFAULT_FLAG_BASE_URL` in shared-components).
 */
export const WIDGET_FLAG_BASE_URL: string | null = WIDGET_ASSET_BASE_URL
  ? `${WIDGET_ASSET_BASE_URL}/image/flags`
  : null;
